module["exports"] = [
  "02# #### ####",
  "02## #### ####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/vi/phone_number/formats.js
// module id = 3694
// module chunks = 1610